import React from 'react'
import { FieldArray } from 'formik'

import { Input, Select, FormRow } from 'components/Forms'
import { AutomaticButtonGroup } from 'components/UI'
import { Button as MerinioButton, List } from 'ui'
import { t } from 'translations'

const UserEmailsForm = ({ disabled, emails }) => {
  return (
    <FieldArray name="emails">
      {props => {
        const options = [
          { _id: 'WORK', name: t('WORK') },
          { _id: 'PERSONEL', name: t('PERSONEL') }
        ]
        return (
          <>
            <div className="mb-2">
              <List className="mb-2">
                {emails.map((email, index) => (
                  <List.Item className="d-flex align-items-center" key={index}>
                    <FormRow>
                      <Input module="employee.myProfile" type="email" name={`emails[${index}].address`} translation="address" required disabled={disabled} />
                      <Select module="employee.myProfile" name={`emails[${index}].type`} options={options} translation="type" required disabled={disabled} />
                    </FormRow>

                    <div className="ml-2 ml-md-auto">
                      <AutomaticButtonGroup>
                        <MerinioButton type="button" color="secondary" onClick={() => props.move(index, index - 1)} disabled={index === 0 || disabled} outlined>
                          <i className="fas fa-arrow-up"></i>
                        </MerinioButton>
                        <MerinioButton
                          type="button"
                          color="secondary"
                          onClick={() => props.move(index, index + 1)}
                          disabled={index === emails.length - 1 || disabled}
                          outlined
                        >
                          <i className="fas fa-arrow-down"></i>
                        </MerinioButton>
                        <MerinioButton
                          type="button"
                          color="secondary"
                          onClick={() => {
                            props.remove(index)
                          }}
                          disabled={disabled}
                          outlined
                        >
                          <i className="fas fa-trash"></i>
                        </MerinioButton>
                      </AutomaticButtonGroup>
                    </div>
                  </List.Item>
                ))}
              </List>
              {!emails.length && <div className="mb-3">{t('manager.users.form.NO_EMAILS')}</div>}
              <MerinioButton type="button" color="secondary" onClick={() => props.push({ address: '', type: 'WORK' })} disabled={disabled} outlined>
                {t('employee.myProfile.ADD_EMAIL')}
              </MerinioButton>
            </div>
          </>
        )
      }}
    </FieldArray>
  )
}

export default UserEmailsForm
